/* eslint-disable no-barrel-files/no-barrel-files */
import type { FC } from 'react'
import React, { lazy, Suspense } from 'react'
import type { PlotParams } from 'react-plotly.js'

// Defer the hefty Plotly runtime until a chart actually renders.
const loadForecastPlotly = () => import('./ForecastPlotly')
const ForecastPlotly = lazy(loadForecastPlotly)

const RawPlot: FC<PlotParams> = (props) => {
  return React.createElement(
    Suspense,
    { fallback: null },
    React.createElement(ForecastPlotly, props)
  )
}

const Plot = React.memo(RawPlot)

export const showPointHover = async (
  graphDiv: HTMLElement,
  curveNumber: number,
  pointNumber: number
): Promise<void> =>
  (await loadForecastPlotly()).showPointHover(
    graphDiv,
    curveNumber,
    pointNumber
  )

export const hidePointHover = async (graphDiv: HTMLElement): Promise<void> =>
  (await loadForecastPlotly()).hidePointHover(graphDiv)

export default Plot
export type { Layout, PlotlyHTMLElement } from './ForecastPlotly'
